module.exports = __webpack_public_path__ + "img/HR53056966535.4bf3898f.png";